<template>
  <div class="enter-wrap">
    <!-- 24.5.17 企业展示 dxm -->
    <div class="container">
      <h2 class="h2-title h2-btitle">{{$t("home.show")}}</h2>
      <div class="logo-list">
        <div class="logo" v-for="(item, index) in enterpriseList" :key="index" @click="changeDetail(item)">
          <div class="img-wrap">
            <img class="img" :src="$imgUrl+item.thumb" alt="" />
          </div>
          <div class="text">{{$t("home.booth")}}：{{ item.remark }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    enterpriseList:Array
  },
  data() {
    return {
    };
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
  },
  methods:{
    changeDetail(item){
      this.$emit('changeDetail',item)
    }
  }
};
</script>
<style lang="scss" scoped>
.enter-wrap {
  width: 100%;
  height: 850px;
  padding: 69px 0 100px;
  box-sizing: border-box;
  background: url("../../../assets/bj.jpg") no-repeat;
  background-size: 100% 100%;
  .logo-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    .logo {
      width: 240px;
      height: 120px;
      padding: 16px 12px 0;
      box-sizing: border-box;
      margin: 0 20px 20px 0;
      background: #fff;
      text-align: center;
      cursor: pointer;
      &:hover .text{
        color: #233889;
      }
      &:nth-child(5n) {
        margin-right: 0;
      }
      .img-wrap {
        width: 100%;
        height: 63px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .img{
          max-width: 100%;
          max-height: 100%;
        }
      }
      .text {
        margin-top: 9px;
        font-size: 14px;
        color: #2c2c2e;
        line-height: 22px;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .enter-wrap {
    .logo-list {
      .logo {
        width: 18%;
        height: 110px;
        margin: 0 2% 2% 0;
        .img-wrap{
          height: 50px;
        }
      }
    }
  }
}
@media only screen and (max-width: 1000px) {
  .enter-wrap {
    .logo-list {
      .logo {
        height: 100px;
        padding: 10px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .enter-wrap {
    height: auto;
    padding: 25px 0 50px;
    .logo-list {
      margin-top: 15px;
      padding-left: 10px;
      .logo {
        width: 23%;
        height: auto;
        padding: 5px;
        margin: 0 2% 2% 0;
        &:nth-child(4n){
          margin-right: 0;
        }
        &:nth-child(5n){
          margin-right: 2%;
        }
        .img-wrap{
          height: 50px;
        }
        .text{
          font-size: 12px;
          margin-top: 3px;
          text-align: center;
        }
      }
    }
  }
}
</style>